import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const contextStyles = makeStyles((theme: Theme) =>
  createStyles({
    contextMenu: {
      backgroundColor: '#fff',
      borderRadius: '5px',
      padding: '5px 0',
      margin: 0,
      /* use absolute positioning  */
      position: 'absolute',
      liststyle: 'none',
      border: '1px solid #444',
      boxShadow: '0 0 5px 0 #444',
      opacity: 1,
      transition: 'opacity 0.5s linear',
      zIndex: 100,
    },
    options: {
      margin: 0,
      padding: 0,
      '& li': {
        fontSize: '0.75rem',
        listStyle: 'none',
        lineHeight: '25px',
        paddingLeft: '0.3rem',
        paddingRight: '0.3rem',
      },
    },
    header: {
      color: '#0F0F0F',
      cursor: 'default',
      fontSize: '1rem !important',
      fontWeight: 700,
      borderBottom: '1px solid #c3c3c3',
      // marginTop: 5,
      // marginBottom: 5,
      marginLeft: '0.3rem',
      lineHeight: '20px !important',
      paddingLeft: '0 !important',
      paddingBottom: '5px !important',
      marginBottom: '0 !important',
      // '& +li':{
      //     marginTop: ''
      //     color: 'red !important',
      // }
    },
    subHeader: {
      color: '#36454F',
      fontSize: '0.9rem !important',
      fontWeight: 600,
      cursor: 'default',
      borderTop: '1px solid #c3c3c3',
      marginTop: 15,
      marginLeft: '0.3rem',
      lineHeight: '20px !important',
      paddingLeft: '0 !important',
      paddingBottom: '0 !important',
      marginBottom: '0 !important',
      // '& +li':{
      //     marginTop: ''
      //     color: 'red !important',
      // }
    },
    active: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#cecece',
      },
    },
    disabled: {
      color: 'grey',
      cursor: 'default',
    },
    intend: {
      paddingLeft: '0.8rem !important',
      // paddingRight: '0.6rem',
    },
  }),
);

export { contextStyles };
